import React, {useState, useEffect, useRef} from "react";
import { StyledDiv, StyledIndexContainerDiv, StyledLeadContainer } from "../../Components/Styled";
import { handleValidateCodevalue, DEFAULT_CHART_DATE_RANGE_DAYS } from "../../Utility/constant";
import { useSelector, useDispatch } from "react-redux";
import { Box, Button, Typography } from "@mui/material";
import { Stack } from "@mui/material";
import { useLocation } from 'react-router-dom';
import { SourceLeadChart } from "./SourceLeadBar";
import BiztantuLineChart from "./BiztantuLineChart";
import { LeadClosedChart } from "./LeadClosedPie";
import { handleRequestGetInvoice, handleRequestGetLead, handleRequestGetOrder } from "../../Store/dashboard/action";
import BusinessIntelligenceDialog from '../../Components/BusinessIntelligenceDialog';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import Actionables from "./Actionables";
import { useIsMobile } from "../../Utility/hooks/useIsMobile";
import LeadAccordion from "../../Components/LeadAccordion";
import qs from "qs";
import { buildChartQueryParams } from "../../Utility/ownerUtils";
import { useDashboardUserScope } from "../../Utility/hooks/useDashboardUserScope";
import "./Dashboard.css";


const BiztantuDashboard = () => {

    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);
    
    const {
        currentUser,
        ownerlist,
        myTeam,
        isLeadEntireOrg,
        isOrderEntireOrg,
        isInvoiceEntireOrg,
        isEntireOrg,
        isTeamRequired,
        getQueryOwnerIds
    } = useDashboardUserScope();

    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    
    const dispatch = useDispatch();
    const [isBIDialogOpen, setIsBIDialogOpen] = useState(false);
    
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const isDemoMode = searchParams.get('demo') === 'true';

    const [chartsState, setChartsState] = useState({ isExpanded: false, isLoading: false });
    const { isExpanded: isChartsExpanded, isLoading: isChartsLoading } = chartsState;

    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    useEffect(() => {
        if (!specificRolePermission) return;

        setChartsState(prev => ({
            ...prev,
            isExpanded: !(
                specificRolePermission.isLeadView ||
                specificRolePermission.isTaskView
            ),
        }));
    }, [specificRolePermission]);
    const handleAccordionChange = (event, isExpanded) => {
        setChartsState(prev => ({ ...prev, isExpanded }));
    };

    // Keep a stable ref to getQueryOwnerIds so the data-fetch effect below can
    // always read the latest version without listing the function as a dependency
    // (which would cause an infinite loop because the function reference changes
    // on every render when ownerlist/myTeam Redux selectors return new arrays).
    const getQueryOwnerIdsRef = useRef(getQueryOwnerIds);
    useEffect(() => {
        getQueryOwnerIdsRef.current = getQueryOwnerIds;
    });

    useEffect(() => {
        if (!isChartsExpanded || !currentUser) return;

        if (isTeamRequired && (!myTeam || myTeam.length === 0)) return;
        if (isEntireOrg && (!ownerlist || ownerlist.length === 0)) return;

        const loadInitialData = async () => {
            setChartsState(prev => ({ ...prev, isLoading: true }));

            const leadqueryparam = buildChartQueryParams(getQueryOwnerIdsRef.current('lead'), DEFAULT_CHART_DATE_RANGE_DAYS);
            const orderqueryparam = buildChartQueryParams(getQueryOwnerIdsRef.current('order'), DEFAULT_CHART_DATE_RANGE_DAYS);
            const invoicequeryparam = buildChartQueryParams(getQueryOwnerIdsRef.current('invoice'), DEFAULT_CHART_DATE_RANGE_DAYS);

            
            try {
                await Promise.all([
                    dispatch(handleRequestGetLead({params: leadqueryparam, paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })}, true)),
                    dispatch(handleRequestGetInvoice({params: orderqueryparam, paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })}, true)),
                    dispatch(handleRequestGetOrder({params: invoicequeryparam, paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })}, true))
                ]);
            } catch (err) {
                console.error("Error loading initial charts data", err);
            } finally {
                setChartsState(prev => ({ ...prev, isLoading: false }));
            }
        };

        loadInitialData();
    }, [isChartsExpanded, currentUser, ownerlist, myTeam, isTeamRequired, isEntireOrg]);
   
    const [dataset, setDataset] = useState({
        leadData: [],
        leadFilterData: [],
        orderData: [],
        userData: [],
        productData: []
    })


    
    
    return (
        
    <StyledDiv>
        <Box className="dashboard-top-header">
            <StyledLeadContainer>
                <Typography variant='h6' className='mb-20'>
                    {handleValidateCodevalue(internationalise,'DASHBOARD_LABEL')}
                </Typography>
            </StyledLeadContainer>

            {isDemoMode && (
                <StyledLeadContainer>
                    <Button
                        className='biztantu-sec-btn'
                        variant="outlined"
                        startIcon={<AnalyticsIcon />}
                        onClick={() => setIsBIDialogOpen(true)}
                    >
                        Business Intelligence
                    </Button>
                </StyledLeadContainer>
            )}
        </Box>
            
            <StyledIndexContainerDiv className="globalBox-dashboard hide-scrollbar dashboard-content-scroll-container">
                <Box>
                    {(specificRolePermission?.isLeadView || specificRolePermission?.isTaskView) &&
                        <Stack display={"flex"} flexDirection={"row"} justifyContent={"space-between"} width={"100%"} className="dashboard-actionables-wrapper">
                            <Stack width={"100%"} className="dashboard-actionables-container">
                                <Actionables />
                            </Stack>
                        </Stack>
                    }

                    <Stack display={"flex"} flexDirection={"row"} justifyContent={"space-between"} width={"100%"} className="dashboard-actionables-wrapper">
                        {/* <LeadAccordion sx={{ width: "100%" }}
                            label={handleValidateCodevalue(internationalise, 'DASH_QUICK_SUMM_ACTION')}
                            expanded={isChartsExpanded}
                            onChange={handleAccordionChange}
                            TransitionProps={{ unmountOnExit: true }}
                        >
                            <Box sx={{ width: '99%', marginLeft: "8px", typography: 'body1', backgroundColor: "transparent" }}>
                                <Stack display={"flex"} flexDirection={"row"} justifyContent={"space-between"} width={"100%"} sx={{ padding: "10px" }}>
                                    <Stack sx={{ width: "100%", border: "1px solid lightgray", height: "38vh", minHeight: 0, overflow: "hidden" }}>
                                        <SourceLeadChart
                                            // dashboarddataset= {dataset}
                                            internationalise={internationalise}
                                            isParentLoading={isChartsLoading}
                                        />
                                    </Stack>
                                </Stack>

                                <Stack display={"flex"} flexWrap={"wrap"} gap={"16px"} flexDirection={"row"} marginTop={"12px"} justifyContent={"space-between"} width={"100%"} sx={{ padding: "10px" }}>
                                    <Stack sx={{ width: !isMobile ? "49%" : "100%", border: "1px solid lightgray", height: "38vh", minHeight: 0, overflow: "hidden" }}>
                                        <LeadClosedChart 
                                            dashboarddataset={dataset}
                                            internationalise={internationalise}
                                            isParentLoading={isChartsLoading}
                                        />
                                    </Stack>

                                    <Stack sx={{ width: !isMobile ? "49%": "100%", border: "1px solid lightgray", height: "38vh", minHeight: 0, overflow: "hidden" }}>
                                        <BiztantuLineChart 
                                            dashboarddataset={dataset}
                                            currentUser={currentUser}
                                            internationalise={internationalise}
                                            isParentLoading={isChartsLoading}
                                        />
                                    </Stack>   
                                </Stack>      
                            </Box>
                        </LeadAccordion> */}
                    </Stack>
                </Box>
            </StyledIndexContainerDiv>
            <BusinessIntelligenceDialog
                open={isBIDialogOpen}
                handleClose={() => setIsBIDialogOpen(false)}
            />
            </StyledDiv>
    )
}

export default BiztantuDashboard;